/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [sidebar-entry-space.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.02.20, 11:32
 */

import React from 'react';
import SpaceAccessIcon from "../../navigation/icons/space-access-icon";
import {getImageServerMediumUrl} from "../../../actions/environment";
import {Link} from "react-router-dom";
import {MarkDownText} from "../../toggler/markdown-text-toggler";
import {formatFnsToNow, useLanguage} from "../../configuration/configuration";

// multiple images in a square box
export const GalleryPictureBox = ({media, size, className}) => {

    const renderPlaceHolder =  () => {
        return <svg className="image-micro-gallery-3x3-flex" xmlns="http://www.w3.org/2000/svg">
            <rect width="100%" height="100%" fill="#868e96"></rect>
        </svg>
    }

    const renderCells = (media) => {
        const cells =  media.map((entry, idx) => {
            return (<td key={idx}>
                {entry.url ? <img className="image-micro-gallery-3x3-flex" src={getImageServerMediumUrl(entry.url)}/>
                    : renderPlaceHolder()}
            </td>)
        })
        return cells.length > 0 ? (<>{cells}</>) : <td>{renderPlaceHolder()}</td>
    }

    const renderRow = (media, key) => {
        return (<tr key={key}>{renderCells(media)}</tr>)
    }

    // build a size x size squared table
    const renderSquaredTable = (media, size) => {

        if(media.length < size*size) {
            const filler = Array(size*size - media.length)
                .fill({url:null});
            media = media.concat(filler);
        }
        const keys = [...Array(size).keys()]
        const rows = keys.map(key => {
            return renderRow(media.slice(key*size, (key+1)*size), key);
        })
        const headers = keys.map(key => {
            return <th/>
        })

        return <table className={`${className}`}>
            <thead><tr>{headers}</tr></thead>
            <tbody>{rows}</tbody>
        </table>
    }

    if (!media) return null;
    return <div>{renderSquaredTable(media, size)}</div>
}

// kind of same as below but takes inline params
export const GalleryBoxedSpace = ({media, username, spacename, spaceId, access, description, className}) => {
    const target = `/${username}/gallery/${spaceId}`

    return <div className={`d-flex justify-content-between bg-white ${className}`}>
        <Link to={target} className="w-100 h-100">
            <div className="d-flex gal-flex-colum gal-flex-row">
                <div className="gal-w-100">
                    <GalleryPictureBox media={media} size={3}/>
                </div>
                <div className="w-100 h-100 px-2 py-1">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="sidebar-space-text">{spacename}</span>
                        <SpaceAccessIcon access={access}/>
                    </div>
                    {description && <MarkDownText text={description} className='text-dark'/>}
                </div>
            </div>
        </Link>
    </div>
}

// same as above buta takes a space as input
const GalleryEntrySpace = ({space, className, text=null, size='small'}) => {
    const Lang = useLanguage();

    const target = `/${space.username}/gallery/${space.spaceId}`
    const media = space.mediaUrl.map(url => {return {url: url}})

    return <div className={`d-flex justify-content-between bg-white ${className}`}>
        <Link to={target} className="w-100 h-100">
            <div className="d-flex gal-flex-colum gal-flex-row">
                <div className="gal-w-100">
                    <GalleryPictureBox media={media} size={3}/>
                </div>
                <div className="w-100 h-100 px-2 py-1">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="sidebar-space-text">{space.name}</span>
                        <SpaceAccessIcon access={space.access}/>
                    </div>
                    <div className='sidebar-space-text mb-2'>
                        <span className="mr-1">{Lang.gallery.headline.updated}</span>
                        {space.updated && formatFnsToNow(space.updated)}
                    </div>
                    <div>
                        {text && <MarkDownText truncate={80} text={text} className='text-dark'/>}
                    </div>
                </div>
            </div>
        </Link>
    </div>
}

export default GalleryEntrySpace;
